import React from "react";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { useDraggable } from "../useDraggable";
import { STANDE } from "../../standeTokens";

const Chip = ({ children, strong }) => (
  <Box
    as="span"
    px="8px"
    py="2px"
    borderRadius="200px"
    fontSize="11px"
    fontWeight={strong ? "600" : "400"}
    bg={strong ? STANDE.primaryBlue : STANDE.grey}
    color={STANDE.black}
    whiteSpace="nowrap"
  >
    {children}
  </Box>
);

/**
 * A question dropped onto the board from the bank, for the class to talk
 * about together. Paper-coloured whatever the theme — it is a page from a
 * paper — and moved like a note. What was asked travels with it (the text,
 * its marks, where it came from), so the board still makes sense later.
 */
const QuestionCard = ({ item, isSelected, readOnly, onMove, onSelect }) => {
  const { onPointerDown } = useDraggable({
    x: item.x,
    y: item.y,
    onMove,
    onStart: onSelect,
    disabled: readOnly,
  });

  return (
    <Box
      position="absolute"
      left={`${item.x}px`}
      top={`${item.y}px`}
      width={`${item.width || 380}px`}
      p="16px"
      borderRadius="14px"
      bg={STANDE.cream}
      border="1px solid rgba(34,34,34,0.08)"
      boxShadow={isSelected ? "0 14px 30px -14px rgba(0,0,0,0.4)" : "0 8px 22px -14px rgba(0,0,0,0.3)"}
      cursor={readOnly ? "default" : "grab"}
      _active={{ cursor: readOnly ? "default" : "grabbing" }}
      onPointerDown={onPointerDown}
      transition="box-shadow 0.15s"
      data-question-card
    >
      <Flex gap="6px" wrap="wrap" mb="10px">
        {item.label && <Chip strong>{item.label}</Chip>}
        {item.marks != null && <Chip>{item.marks} {item.marks === 1 ? "mark" : "marks"}</Chip>}
        {item.topic && <Chip>{item.topic}</Chip>}
      </Flex>
      <Text fontSize="15px" lineHeight="1.45" color={STANDE.black} whiteSpace="pre-wrap">
        {item.text}
      </Text>
      {item.image && (
        <Image src={item.image} alt="" mt="10px" borderRadius="8px" maxH="200px" objectFit="contain" draggable={false} />
      )}
      {item.source && (
        <Text fontSize="11px" color="rgba(34,34,34,0.5)" mt="10px">
          {item.source}
        </Text>
      )}
    </Box>
  );
};

export default QuestionCard;
